export const perfFlags = {
    DISABLE_SOCIAL: 'DISABLE_SOCIAL',
    DISABLE_SB_ADS: 'DISABLE_SB_ADS',
    DISABLE_DATA_DOG: 'DISABLE_DATA_DOG',
};

type PerfFlags = keyof typeof perfFlags;

const perFlagsQpMap = {
    //  won't load fb, google and apple scripts initially
    [perfFlags.DISABLE_SOCIAL]: '__d0',
    // disables data dog RUM
    [perfFlags.DISABLE_DATA_DOG]: '__d1',
    // disables all ad units from S/B
    [perfFlags.DISABLE_SB_ADS]: '__d2',
};

export function getPerfQp(flag: PerfFlags): string {
    return perFlagsQpMap[flag];
}
